



















































import BaseFormEdit from "../../models/base.form.edit";
import {Component} from "vue-property-decorator";

@Component({})
export default class Edit extends BaseFormEdit {
    form = {description: "", dateBegin: new Date(), dateEnd: new Date()} as any;
    }
